import React from 'react';

import { useIntl } from 'react-intl';

import { IconButton, LinkIconButton } from '@atlaskit/button-next/new';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { Inline, Stack, Text } from '@atlaskit/primitives-next';

import { getMarathonRunbookUrl } from '@/common/routes/utils';

import { messages } from '../messages';

type RunbookCardHeaderProps = {
	runbookId: string;
	title: string;
	isExpanded: boolean;
	onToggle: () => void;
	onOpenInMarathon: () => void;
};

export const RunbookCardHeader: React.FC<RunbookCardHeaderProps> = ({
	runbookId,
	title,
	isExpanded,
	onToggle,
	onOpenInMarathon,
}) => {
	const intl = useIntl();
	const runbookUrl = getMarathonRunbookUrl(runbookId);

	return (
		<Inline alignBlock="center" spread="space-between" space="space.100">
			<Inline alignBlock="center" space="space.100" grow="fill">
				<IconButton
					appearance="subtle"
					spacing="compact"
					label={intl.formatMessage(
						isExpanded
							? messages.runbooksPanelCollapseRunbookLabel
							: messages.runbooksPanelExpandRunbookLabel,
						{ title },
					)}
					icon={isExpanded ? ChevronDownIcon : ChevronRightIcon}
					onClick={onToggle}
					testId={`runbook-toggle-${runbookId}`}
				/>
				<Stack space="space.050" grow="fill">
					<Text weight="medium">{title}</Text>
				</Stack>
			</Inline>
			<LinkIconButton
				href={runbookUrl}
				target="_blank"
				rel="noreferrer"
				appearance="subtle"
				spacing="compact"
				icon={LinkExternalIcon}
				onClick={onOpenInMarathon}
				label={intl.formatMessage(messages.runbooksPanelOpenRunbookLabel, { title })}
			/>
		</Inline>
	);
};
